<template>
  <div 
    v-if="visivel"
    id="configuracoes-financeiro"
    style="display: block;" 
    class="w3-modal"
    v-cloak>
    
    <div class="w3-modal-content" style="width: 82%;" @click.stop v-cloak>
      <header style="padding:0px">
        <span @click="fechar()" class="w3-button w3-display-topright">&times;</span>
        <h5>
          <b><i class="fa fa-cog"></i> Configurações</b>
        </h5>
      </header>

      <div>
        <h5
          class="titulo texto-vermelho w3-margin-bottom"
          style="margin-top: 0">
          <span>Opções principais</span>
        </h5>

          <div 
            class="w3-col s12 m12 l12 w3-margin-bottom"
            v-if="processando">
            
            <div class="w3-panel ">
              <p class="w3-theme w3-card-2 w3-padding">
                <i class="fa fa-sync-alt w3-spin"></i><span> Processando...</span>
              </p>
            </div>
          </div>
        </div>
      
        <div class="w3-block w3-row" >
          <div 
            class="w3-container" 
            style="padding: 0px;"
            v-if="!processando">
            <div class="w3-block">
              <div class="container">
                <button 
                  v-if="ativar_todos_financeiro" 
                  @click="ativarDesativarFinanceiro(true)"
                  class="w3-button w3-green w3-round-xxlarge w3-margin-bottom w3-col s12 m4 l3">
                  <i class="fas fa-check"></i>
                  <span> Marcar todos</span>
                </button>
              
                <button 
                  v-if="desativar_todos_financeiro" 
                  @click="ativarDesativarFinanceiro(false)"
                  class="w3-button w3-red w3-round-xxlarge w3-margin-bottom w3-col s12 m6 l6">
                  <i class="fas fa-times"></i>
                  <span> Desmarcar todos</span>
                </button>
              
                <div class="w3-block w3-row">
                  <div class="w3-col s12 m6 l4">
                    <div class="agrupador">
                      <strong>Saldos de caixas e bancos</strong>
                    </div>
                    
                    <div class="checkbox-group">
                      <input
                        type="checkbox"
                        class="switch-input"
                        id="saldos-caixas-bancos-conta-caixa" 
                        v-model="configuracoes.visibilidade.contas_caixa">
                      
                      <label
                        class="switch-label"
                        for="saldos-caixas-bancos-conta-caixa">
                        <span>Conta caixa</span>
                      </label>
                    </div>
                    
                    <div class="checkbox-group">
                      <input 
                        type="checkbox"
                        class="switch-input"
                        id="saldos-caixas-bancos-contas-bancarias" 
                        v-model="configuracoes.visibilidade.contas_bancarias">
                      
                      <label
                        class="switch-label"
                        for="saldos-caixas-bancos-contas-bancarias">
                        <span>Contas bancárias</span>
                      </label>
                    </div>
                  </div>

                  <div class="w3-col m6 l4">
                    <div class="agrupador">
                      <strong>Realizado até o início do relatório</strong>
                    </div>

                    <div class="checkbox-group">
                      <input 
                        type="checkbox" 
                        class="switch-input"
                        id="inicio-receber"
                        v-model="configuracoes.visibilidade.receber_realizado">
                      <label class="switch-label" for="inicio-receber">A receber</label>
                    </div>

                    <div class="checkbox-group">
                      <input 
                        type="checkbox" 
                        class="switch-input"
                        id="inicio-cheques-pagar"
                        v-model="configuracoes.visibilidade.cheques_pagar">

                      <label
                        class="switch-label"
                        for="inicio-cheques-pagar">
                        <span>Cheques a pagar</span>
                      </label>
                    </div>

                    <div class="checkbox-group">
                      <input 
                        type="checkbox"
                        class="switch-input"
                        id="inicio-pagar-duplicata-cheque-abertos" 
                        v-model="configuracoes.visibilidade.pagar_duplicata_cheques_abertos">

                      <label
                        class="switch-label"
                        for="inicio-pagar-duplicata-cheque-abertos">
                        <span>A pagar (duplicata e cheque abertos)</span>
                      </label>
                    </div>

                    <div class="checkbox-group">
                      <input 
                        type="checkbox"
                        class="switch-input"
                        id="inicio-dbc-pagar-vencidos" 
                        v-model="configuracoes.visibilidade.dbc_pagar_vencidos">

                      <label
                        class="switch-label"
                        for="inicio-dbc-pagar-vencidos">
                        <span>Duplicata/boleto/crédito a pagar (vencidos)</span>
                      </label>
                    </div>
                  </div>

                  <div class="w3-col m6 l4">
                    <div class="agrupador">
                      <strong>Previsões até o início do relatório</strong>
                    </div>

                    <div class="checkbox-group">
                      <input 
                        type="checkbox"
                        class="switch-input"
                        id="previsoes-pagar"
                        v-model="configuracoes.visibilidade.pagar_previsoes">
                      <label class="switch-label" for="previsoes-pagar">A pagar</label>
                    </div>

                    <div class="checkbox-group">
                      <input
                        type="checkbox"
                        class="switch-input"
                        id="previsoes-receber"
                        v-model="configuracoes.visibilidade.receber_previsoes">
                      <label class="switch-label" for="previsoes-receber">A receber</label>
                    </div>
                  </div>

                  <div class="w3-col m6 l3">
                    <div class="agrupador">
                      <strong>Títulos a receber vencidos a N dias (acumulado)</strong>
                      <strong> - somente informativo</strong>
                    </div>

                    <div class="checkbox-group">
                      <input
                        type="checkbox"
                        class="switch-input"
                        id="titulo-3dias"
                        v-model="configuracoes.visibilidade.tres_dias">

                      <label class="switch-label" for="titulo-3dias">3 dias</label>
                    </div>

                    <div class="checkbox-group">
                      <input
                        type="checkbox"
                        class="switch-input"
                        id="titulo-15dias"
                        v-model="configuracoes.visibilidade.quinze_dias">

                      <label class="switch-label" for="titulo-15dias">15 dias</label>
                    </div>

                    <div class="checkbox-group">
                      <input
                        type="checkbox"
                        class="switch-input"
                        id="titulo-30dias"
                        v-model="configuracoes.visibilidade.trinta_dias">

                      <label class="switch-label" for="titulo-30dias">30 dias</label>
                    </div>

                    <div class="checkbox-group">
                      <input 
                        type="checkbox" 
                        class="switch-input" 
                        id="titulo-60dias"
                        v-model="configuracoes.visibilidade.sessenta_dias">
                      <label class="switch-label" for="titulo-60dias">60 dias</label>
                    </div>

                    <div class="checkbox-group">
                      <input 
                        type="checkbox" 
                        class="switch-input" 
                        id="titulo-90dias"
                        v-model="configuracoes.visibilidade.noventa_dias">
                      <label class="switch-label" for="titulo-90dias">90 dias</label>
                    </div>

                    <div class="checkbox-group">
                      <input 
                        type="checkbox"
                        class="switch-input"
                        id="previsoes-pagar-vencidas"
                        v-model="configuracoes.visibilidade.previsoes_pagar_vencidas">

                      <label
                        class="switch-label"
                        for="previsoes-pagar-vencidas">
                        <span>Previsões a pagar vencidas</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="w3-block w3-row-padding">
              <h5
                class="titulo texto-vermelho w3-margin-bottom"
                style="margin-top: 0">
                <span>Configurações adicionais</span>
              </h5>

              <div>
                <div class="w3-col">
                  <div class="data">
                    <div class="w3-col s12 m6">
                      <label for="quantidade_dias">
                        <strong>Qtd. dias processamento</strong>
                      </label>

                      <input 
                        type="number" 
                        class="w3-input w3-border w3-col s12"
                        name="quantidade_dias"
                        id="quantidade_dias"
                        v-model="configuracoes.quantidade_dias"/>
                    </div>

                    <div class="w3-col s12 m6">
                      <label for="tipo_saldo"><strong>Tipo de saldo</strong></label>

                      <select
                        class="w3-input w3-border"
                        name="tipo_saldo"
                        id="tipo_saldo"
                        v-model="configuracoes.tipo_saldo">

                        <option value="TSE" checked="checked">Saldo de extrato</option>
                        <option value="TSD">Digitado</option>
                        <option value="TSC">Conciliado</option>
                      </select>

                      <div class="w3-margin-top" v-if="configuracoes.tipo_saldo == 'TSD'" >
                        <label for="saldo_conta_fluxo">
                          <strong>Saldo contas bancárias</strong>
                        </label>

                        <input 
                          class="w3-input w3-border"
                          value="0,00" 
                          type="text"
                          v-model="configuracoes.saldo_conta_fluxo"
                          id="saldo_conta_fluxo"
                          name="saldo_conta_fluxo">
                      </div>
                    </div>
                  </div>

                  <div class="w3-col s12 m12 l12 w3-margin-top">
                    <strong class="w3-col s12 m12">Forma de pagamento (contas a pagar)</strong>
                    <div class="w3-row w3-col s12 m6" style="text-align: right">
                      <button
                        @click="marcarDesmarcarTodosTiposDocumento"
                        :class="
                          'botao-marcar-todos w3-button w3-green w3-round-xlarge ' +
                          'w3-margin-bottom w3-col s12 m6 l4'">
                        <span>{{getTituloBotaoTiposDocumentos}}</span>
                      </button>
                    </div>

                    <div class="w3-row grupo-contas-pagar w3-margin-bottom">
                      <div class="w3-col s12 m6 l4">
                        <input
                          class="w3-check"
                          id="boleto"
                          v-model="configuracoes.formas_pagamento.forma_boleto"
                          type="checkbox">

                        <label for="boleto">Boleto</label>
                      </div>

                      <div class="w3-col s12 m6 l4">
                        <input
                          class="w3-check"
                          id="cheque_a_prazo"
                          v-model="configuracoes.formas_pagamento.forma_cheque_prazo"
                          type="checkbox">

                        <label for="cheque_a_prazo">Cheque a prazo</label>
                      </div>

                      <div class="w3-col s12 m6 l4">
                        <input
                          class="w3-check"
                          id="duplicata"
                          v-model="configuracoes.formas_pagamento.forma_duplicata"
                          type="checkbox">
                        
                        <label for="duplicata">Duplicata</label>
                      </div>
                      
                      <div class="w3-col s12 m6 l4">
                        <input
                          class="w3-check"
                          id="credito"
                          v-model="configuracoes.formas_pagamento.forma_credito"
                          type="checkbox">

                        <label for="credito">Crédito</label>
                      </div>

                      <div class="w3-col s12 m6 l4">
                        <input
                          class="w3-check"
                          id="cheque_a_vista"
                          v-model="configuracoes.formas_pagamento.forma_cheque_vista"
                          type="checkbox">

                        <label for="cheque_a_vista">Cheque à vista</label>
                      </div>

                      <div class="w3-col s12 m6 l4">
                        <input
                          class="w3-check"
                          id="previsao"
                          v-model="configuracoes.formas_pagamento.forma_previsao"
                          type="checkbox">

                        <label for="previsao">Previsão</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="w3-col" v-if="!processando">
                  <div class="w3-col items borda-pontilhada">
                    <strong class="w3-col">Desconsiderar contas</strong>                  

                    <button
                      class="w3-btn w3-theme"
                      @click="mostrar_modal_contas_desconsiderar_ids = true">
                      <i class="fa fa-plus"></i>
                    </button>

                    <p
                      class="w3-col"
                      v-show="!temContaDesconsiderarSelecionada">
                      <span>Não há contas selecionadas.</span>
                    </p>

                    <div class="box_configuracoes">
                    
                      <div
                        style="margin: 2px!important;"
                        class="bloco w3-col s12 m6 l3"
                        v-for="(conta, conta_index) in contas_desconsiderar_ids"
                        v-show="conta.selecionada"
                        :key="conta_index">

                        <div class="w3-col">
                          <div class="w3-col w3-small">
                            <b>{{conta.conta_id}} - {{conta.nome_portador}} </b>
                          </div>
                        </div>

                        <div class="w3-col s12">
                          <button
                            class="w3-button w3-col s12 texto-vermelho"
                            v-on:click="adicionarRemoverContaDesconsiderar(conta.conta_id, false)">
                            <span>Remover conta</span>
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="w3-col s12 m6 l4 items w3-padding-small borda-pontilhada">
                    <div class="w3-col s6">
                      <strong class="w3-col s11 m11 l11">Conta caixa</strong>
                    </div>
                    
                    <div class="w3-col s6">
                      <div class="w3-col s6 w3-padding-small"/>

                      <div class="w3-col s6 w3-padding-small">
                        <button
                          class="w3-btn w3-theme w3-right"
                          @click="mostrar_modal_contas_caixa = true"> 
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>

                    <p class="w3-col s12" v-show="!temContaCaixaSelecionada">
                      <span>Não há contas caixa selecionadas.</span>
                    </p>
                    
                    <div class="box_configuracoes">
                      <div
                        class="bloco w3-col s12" 
                        v-for="(conta_caixa, conta_index) in contas_caixa" 
                        v-show="conta_caixa.selecionada"
                        :key="conta_index">

                        <div class="w3-col s12 w3-row">
                          <div class="w3-col s12 w3-small">
                            <b>{{conta_caixa.conta_id}} - {{conta_caixa.nome_portador}}</b>
                          </div>
                        </div>

                        <div class="w3-col s12 w3-row">
                          <button
                            class="w3-button w3-col s12 texto-vermelho"
                            v-on:click="adicionarRemoverContaCaixa(conta_caixa.conta_id, false)">
                            <span>Remover conta caixa</span>
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="w3-col s12 m6 l4 items w3-padding-small borda-pontilhada">
                    <div class="w3-col s6">
                      <strong class="w3-col s11 m11 l11">Empresa</strong>
                    </div>

                    <div class="w3-col s6">
                      <div class="w3-col s6 w3-padding-small">
                        <button
                          class="w3-btn w3-theme w3-right"
                          @click="omitirEmpresas()"
                          :disabled="!temEmpresaSelecionada">
 
                          <i class="fa fa-eye" v-if="!configuracoes.omissoes.empresas"></i>
                          <i class="fa fa-eye-slash" v-if="configuracoes.omissoes.empresas"></i>
                        </button>
                      </div>

                      <div class="w3-col s6 w3-padding-small">
                        <button
                          class="w3-btn w3-theme w3-right"
                          @click="mostrar_modal_empresas = true">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>

                    <p
                      class="w3-col s12"
                      v-show="!temEmpresaSelecionada">
                      <span>Não há empresas selecionadas.</span>
                    </p>

                    <div class="box_configuracoes">
                      <div
                        class="bloco w3-col s12"
                        v-for="(empresa, index) in empresas"
                        v-show="empresa.selecionada"
                        :key="index">

                        <div class="w3-col s12 w3-row">
                          <div class="w3-col s12 w3-small">
                            <b>{{empresa.empresa_id}} - {{empresa.nome_fantasia}}</b>
                          </div>
                        </div>

                        <div class="w3-col s12 w3-row">
                          <div class="w3-col s12 w3-small">{{empresa.cnpj}}</div>
                        </div>

                        <div class="w3-col s12 w3-row">
                          <button
                            class="w3-button w3-col s12 texto-vermelho"
                            v-on:click="adicionarRemoverEmpresa(empresa.empresa_id, false)">
                            <span>Remover empresa</span>
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div 
                  class="w3-col s12 m12 l12 w3-right" 
                  v-if="!processando">

                  <div class="w3-col s12 m6 l4 items w3-padding-small borda-pontilhada">
                    <div class="w3-col s6">
                      <strong class="w3-col s10 m10 l10">Portador - contas a pagar</strong>
                    </div>

                    <div class="w3-col s6">
                      <div class="w3-col s6 w3-padding-small">
                        <button
                          class="w3-btn w3-theme w3-right"
                          @click="omitirPortadoresContasPagar()"
                          :disabled="!temPortadorPagarSelecionado">

                          <i class="fa fa-eye" v-if="!configuracoes.omissoes.portadores_a_pagar"></i>
                          <i class="fa fa-eye-slash" v-if="configuracoes.omissoes.portadores_a_pagar"></i>
                        </button>
                      </div>

                      <div class="w3-col s6 w3-padding-small">
                        <button
                          class="w3-btn w3-theme w3-right"
                          @click="mostrar_modal_portadores_pagar = true">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>

                    <p
                      class="w3-col s12"
                      v-show="!temPortadorPagarSelecionado">
                      <span>Não há portadores selecionados.</span>
                    </p>
                    
                    <div class="box_configuracoes">
                      <div
                        class="bloco w3-col s12"
                        v-for="(portador, index) in portadores_pagar"
                        v-show="portador.selecionado"
                        :key="index">

                        <div class="w3-col s12 w3-row">
                          <div class="w3-col s12 w3-small">
                            <b>{{portador.portador_id }} - {{portador.nome}}</b>
                          </div>
                        </div>

                        <div class="w3-col s12 w3-row">
                          <button
                            class="w3-button w3-col s12 texto-vermelho" 
                            v-on:click="adicionarRemoverPortadorContasPagar(
                              portador.portador_id,
                              false
                            )">
                            <span>Remover portador</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="w3-col s12 m6 l4 items w3-padding-small borda-pontilhada">     			  
                    <div class="w3-col s6">
                      <strong class="w3-col s10 m10 l10">Portador - contas a receber</strong>
                    </div>

                    <div class="w3-col s6">
                      <div class="w3-col s6 w3-padding-small">
                        <button
                          class="w3-btn w3-theme w3-right"
                          @click="omitirPortadoresContasReceber()"
                          :disabled="!temPortadorReceberSelecionado">
                            <i class="fa fa-eye" v-if="!configuracoes.omissoes.portadores_a_receber"></i>
                            <i class="fa fa-eye-slash" v-if="configuracoes.omissoes.portadores_a_receber"></i>
                        </button>
                      </div>

                      <div class="w3-col s6 w3-padding-small">
                        <button 
                          class="w3-btn w3-theme w3-right"
                          @click="mostrar_modal_portadores_contas_receber = true">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>

                    <p
                      class="w3-col s12"
                      v-show="!temPortadorReceberSelecionado">
                      <span>Não há portadores selecionados.</span>
                    </p>

                    <div class="box_configuracoes">
                      <div
                        class="bloco w3-col s12"
                        v-for="(portador, index) in portadores_receber"
                        v-show="portador.selecionado"
                        :key="index">

                        <div class="w3-col s12 w3-row">
                          <div class="w3-col s6"><b>Portador: </b></div>
                          <div class="w3-col s12 w3-small">
                            <b>{{portador.portador_id}} - {{portador.nome}}</b>
                          </div>
                        </div>

                        <div class="w3-col s12 w3-row">
                          <button 
                            class="w3-button texto-vermelho w3-col s12" 
                            v-on:click="adicionarRemoverPortadorContasReceber(
                              portador.portador_id,
                              false
                            )">
                            <span>Remover portador</span>
                          </button>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="w3-col s12 m6 l4 items w3-padding-small borda-pontilhada">
                    <div class="w3-col s6">
                      <strong class="w3-col s11 m11 l11">Alínea de cheques a pagar</strong>
                    </div>

                    <div class="w3-col s6">
                      <div class="w3-col s6 w3-padding-small">
                        <button
                          class="w3-btn w3-theme w3-right"
                          @click="omitirAlineas()"
                          :disabled="!temAlineaSelecionada">
                            <i class="fa fa-eye" v-if="!configuracoes.omissoes.alineas"></i>
                            <i class="fa fa-eye-slash" v-if="configuracoes.omissoes.alineas"></i>
                        </button>
                      </div>

                      <div class="w3-col s6 w3-padding-small">
                        <button
                          class="w3-btn w3-theme w3-right"
                          @click="mostrar_modal_alineas = true">
                          <i class="fa fa-plus"></i>
                        </button>
                      </div>
                    </div>

                    <p
                      class="w3-col s12"
                      v-show="!temAlineaSelecionada">
                      <span>Não há alíneas selecionadas.</span>
                    </p>
                    
                    <div class="box_configuracoes">
                      <div
                        class="bloco w3-col s12"
                        v-for="(alinea, index) in alineas"
                        v-show="alinea.selecionada"
                        :key="index">

                        <div class="w3-col s12 w3-row">
                          <div class="w3-col s12 w3-small">
                            <b>{{alinea.alinea_id}} - {{alinea.nome}}</b>
                          </div>
                        </div>

                        <div class="w3-col s12 w3-row">
                          <button
                            class="w3-button texto-vermelho w3-col s12"
                            v-on:click="adicionarRemoverAlinea(alinea.alinea_id, false)">
                            <span>Remover alínea</span>
                          </button>
                        </div>

                      </div>
                    </div>

                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      
        <div
          class="w3-block w3-row w3-margin-bottom w3-margin-top"
          v-if="!processando">
          
          <div class="w3-container w3-center">
            <button
              class="w3-button w3-theme"
              @click="gravarConfiguracoes()">
              <i class="fa fa-check"></i><span> Gravar configurações</span>
            </button>
            
            <button
              class="w3-button"
              @click="limparConfiguracoes()">
              <i class="fas fa-recycle"></i>
              <span> Reconfigurar</span>
            </button>
          </div>
        </div>
      </div>

      <div
        id="modalContas"
        class="w3-modal"
        style="display: block;"
        v-if="mostrar_modal_contas_desconsiderar_ids"
        @click="mostrar_modal_contas_desconsiderar_ids = false">

        <div class="w3-modal-content w3-animate-zoom" @click.stop>
          <header class="w3-container">
            <span
              @click="mostrar_modal_contas_desconsiderar_ids = false; filtro = '';"
              class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>

            <h2 class="texto-vermelho  titulo">Contas disponíveis</h2>
          </header>

          <div class="w3-container">
            <div class="w3-col">
              <input
                class="w3-input w3-border w3-padding w3-margin-bottom"
                type="text"
                placeholder="Pesquise pelo número da conta ou portador"
                v-model="filtro"
                id="pesquisa_conta">

              <div 
                class="w3-responsive w3-border" 
                style="max-height: calc(100vh - 320px); min-height: 200px; overflow: auto;" 
                v-if="contas_desconsiderar_ids.length > 0">

                <table class="w3-table w3-border w3-bordered w3-striped w3-white">
                  <thead>
                    <tr>
                      <th>Conta</th>
                      <th>Portador</th>
                      <th style="text-align: right">Empresa</th>
                      <th style="text-align: right">Tipo</th>
                      <th style="text-align: right">Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr
                      v-for="(conta, conta_index) in buscarContasDesconsiderarFiltradas"
                      :key="conta_index"
                      @click="adicionarRemoverContaDesconsiderar(conta.conta_id, !conta.selecionada)"
                      :class="buscarClasseSelecao(conta.selecionada)">

                      <td>{{conta.conta_id}}</td>
                      <td>{{conta.nome_portador}}</td>

                      <td style="text-align: right">
                        <span>{{conta.empresa_id}} - {{conta.nome_empresa}}</span>
                      </td>
                      
                      <td style="text-align: right">{{conta.tipo_analitico}}</td>
                      <td style="text-align: right">{{conta.status}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <footer class="w3-container conteudo-centralizado">
            <button
              class="w3-btn w3-theme"
              id="btn-confirmar-acao"
              style="margin-top: 10px; margin-bottom:10px"
              @click="mostrar_modal_contas_desconsiderar_ids = false; filtro = '';">
              <span>Ok</span>
            </button>
          </footer>

        </div>
      </div>

      <div
        id="modalContasCaixa"
        v-if="mostrar_modal_contas_caixa"
        @click="mostrar_modal_contas_caixa = false"
        style="display: block;"
        class="w3-modal">

        <div class="w3-modal-content w3-animate-zoom" @click.stop>
          <header class="w3-container">
            <span
              @click="mostrar_modal_contas_caixa = false; filtro = '';" 
              class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>

            <h2 class="texto-vermelho titulo">Contas caixa disponíveis</h2>
          </header>

          <div class="w3-container">
            <div class="w3-col">
              <input
                class="w3-input w3-border w3-padding w3-margin-bottom"
                type="text"
                placeholder="Pesquise pelo número da conta ou portador"
                v-model="filtro"
                id="pesquisa_conta">

              <div
                class="w3-responsive w3-border"
                style="max-height: calc(100vh - 320px); min-height: 200px; overflow: auto;"
                v-if="contas_caixa">

                <table class="w3-table w3-border w3-bordered w3-striped w3-white">
                  <thead>
                    <tr>
                      <th>Conta</th>
                      <th>Portador</th>
                      <th style="text-align: right">Empresa</th>
                      <th style="text-align: right">Tipo</th>
                      <th style="text-align: right">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(conta_caixa, conta_index) in buscarContasCaixaFiltradas"
                      :key="conta_index"
                      @click="adicionarRemoverContaCaixa(conta_caixa.conta_id, !conta_caixa.selecionada)"
                      :class="buscarClasseSelecao(conta_caixa.selecionada)">

                      <td>{{conta_caixa.conta_id}}</td>
                      <td>{{conta_caixa.nome_portador}}</td>

                      <td style="text-align: right">
                        <span>{{conta_caixa.empresa_id}} - {{conta_caixa.nome_empresa}}</span>
                      </td>

                      <td style="text-align: right">{{conta_caixa.tipo_analitico}}</td>
                      <td style="text-align: right">{{conta_caixa.status}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <footer class="w3-container conteudo-centralizado">
            <button
              class="w3-btn w3-theme"
              id="btn-confirmar-acao"
              style="margin-top: 10px; margin-bottom:10px"
              @click="mostrar_modal_contas_caixa = false; filtro = '';">
              <span>Ok</span>
            </button>
          </footer>
        </div>
      </div>
      
      <div
        id="modalEmpresas" 
        v-if="mostrar_modal_empresas" 
        class="w3-modal" 
        @click="mostrar_modal_empresas = false" 
        style="display: block">

        <div class="w3-modal-content w3-animate-zoom" @click.stop>
          <header class="w3-container">
            <span 
              @click="mostrar_modal_empresas = false; filtro = '';"
              class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>

            <h2 class="texto-vermelho titulo">Empresas disponíveis</h2>
          </header>

          <div class="w3-container">
            <div class="w3-col">
              <input 
                class="w3-input w3-border w3-padding w3-margin-bottom" 
                type="text" 
                placeholder="Pesquise por código ou nome fantasia" 
                v-model="filtro"
                id="pesquisa_conta">

              <div
                class="w3-responsive w3-border"
                style="max-height: calc(100vh - 320px);min-height: 200px;overflow: auto" 
                v-if="empresas.length > 0">

                <table class="w3-table w3-border w3-bordered w3-striped w3-white">
                  <thead>
                    <tr>
                      <th>Empresa</th>
                      <th>Nome fantasia</th>
                      <th style="text-align: right">CNPJ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="(empresa, empresa_index) in buscarEmpresasFiltradas" 
                      :key="empresa_index"
                      @click="adicionarRemoverEmpresa(
                        empresa.empresa_id, 
                        !empresa.selecionada
                      )" 
                      :class="buscarClasseSelecao(empresa.selecionada)">

                      <td>{{empresa.empresa_id}}</td>
                      <td>{{empresa.nome_fantasia}}</td>
                      <td style="text-align: right">{{empresa.cnpj}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <footer class="w3-container conteudo-centralizado">
            <button 
              class="w3-btn w3-theme"
              id="btn-confirmar-acao" 
              style="margin-top: 10px; margin-bottom:10px" 
              @click="mostrar_modal_empresas = false; filtro = '';">Ok
            </button>
          </footer>
        </div>
      </div>

      <div 
        id="modalPortadorContasPagar"
        class="w3-modal" 
        v-if="mostrar_modal_portadores_pagar" 
        style="display: block" 
        @click="mostrar_modal_portadores_pagar = false">

        <div class="w3-modal-content w3-animate-zoom" @click.stop>
          <header class="w3-container">
            <span
              @click="mostrar_modal_portadores_pagar = false; 
              filtro = '';" 
              class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>

            <h2 class="texto-vermelho titulo">Portadores disponíveis</h2>
          </header>

          <div class="w3-container">
            <div class="w3-col">
              <input
                class="w3-input w3-border w3-padding w3-margin-bottom"
                type="text"
                placeholder="Pesquise por código ou nome"
                v-model="filtro"
                id="pesquisa_conta">

              <div
                class="w3-responsive w3-border"
                style="max-height: calc(100vh - 320px); min-height: 200px; overflow: auto;"
                v-if="portadores_pagar.length > 0">

                <table class="w3-table w3-border w3-bordered w3-striped w3-white">
                  <thead>
                    <tr>
                      <th>Portador</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(portador, portador_index) in buscarPortadoresPagarFiltrados"
                      :key="portador_index"
                      @click="adicionarRemoverPortadorContasPagar(
                        portador.portador_id,
                        !portador.selecionado
                      )"
                      :class="buscarClasseSelecao(portador.selecionado)">

                      <td>{{portador.portador_id}}</td>
                      <td>{{portador.nome}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <footer class="w3-container conteudo-centralizado">
            <button
              class="w3-btn w3-theme"
              id="btn-confirmar-acao"
              style="margin-top: 10px; margin-bottom:10px"
              @click="mostrar_modal_portadores_pagar = false; filtro = '';">Ok
            </button>
          </footer>
        </div>
      </div>

      <div
        id="modalPortadorContasReceber"
        v-if="mostrar_modal_portadores_contas_receber"
        @click="mostrar_modal_portadores_contas_receber = false"
        style="display: block"
        class="w3-modal">

        <div class="w3-modal-content w3-animate-zoom" @click.stop>
          <header class="w3-container">
            <span
              @click="mostrar_modal_portadores_contas_receber = false; filtro = '';"
              class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>

            <h2 class="texto-vermelho titulo">Portadores disponíveis</h2>
          </header>

          <div class="w3-container">
            <div class="w3-col">
              <input
                class="w3-input w3-border w3-padding w3-margin-bottom"
                type="text"
                placeholder="Pesquise por código ou nome"
                v-model="filtro"
                id="pesquisa_conta">

              <div
                class="w3-responsive w3-border"
                style="max-height: calc(100vh - 320px);min-height: 200px;overflow: auto"
                v-if="portadores_receber.length > 0">

                <table class="w3-table w3-border w3-bordered w3-striped w3-white">
                  <thead>
                    <tr>
                      <th>Portador</th>
                      <th>Nome</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(portador, portador_index) in buscarPortadoresReceberFiltrados"
                      :key="portador_index"
                      @click="adicionarRemoverPortadorContasReceber(
                        portador.portador_id,
                        !portador.selecionado
                      )"                      
                      :class="buscarClasseSelecao(portador.selecionado)">

                      <td>{{portador.portador_id}}</td>
                      <td>{{portador.nome}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <footer class="w3-container conteudo-centralizado">
            <button
              class="w3-btn w3-theme"
              id="btn-confirmar-acao"
              style="margin-top: 10px; margin-bottom:10px"
              @click="mostrar_modal_portadores_contas_receber = false; filtro = '';">
              <span>Ok</span>
            </button>
          </footer>
        </div>
      </div>

      <div
        id="modalAlinea"
        class="w3-modal"
        v-if="mostrar_modal_alineas"
        @click="mostrar_modal_alineas = false"
        style="display: block">

        <div class="w3-modal-content w3-animate-zoom" @click.stop>
          <header class="w3-container">
            <span
              @click="mostrar_modal_alineas = false; filtro = '';"
              class="w3-button w3-display-topright w3-text-theme w3-large">&times;</span>

            <h2 class="texto-vermelho titulo">Alíneas disponíveis</h2>
          </header>

          <div class="w3-container">
            <div class="w3-col">
              <input
                class="w3-input w3-border w3-padding w3-margin-bottom"
                type="text"
                placeholder="Pesquise por código ou descrição"
                v-model="filtro"
                id="pesquisa_conta">

              <div
                class="w3-responsive w3-border"
                style="max-height: calc(100vh - 320px);min-height: 200px;overflow: auto"
                v-if="alineas.length > 0">

                <table class="w3-table w3-border w3-bordered w3-striped w3-white">
                  <thead>
                    <tr>
                      <th>Alínea</th>
                      <th>Descrição</th>
                      <th>Permite reapresentação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(alinea, alinea_index) in buscarAlineasFiltradas"
                      :key="alinea_index"
                      @click="adicionarRemoverAlinea(alinea.alinea_id, !alinea.selecionada)"
                      :class="buscarClasseSelecao(alinea.selecionada)">

                      <td>{{alinea.alinea_id}}</td>
                      <td>{{alinea.nome}}</td>
                      <td>{{simNaoString(alinea.permitir_reapresentacao)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <footer class="w3-container conteudo-centralizado">
            <button
              class="w3-btn w3-theme"
              id="btn-confirmar-acao"
              style="margin-top: 10px; margin-bottom:10px"
              @click="mostrar_modal_alineas = false; filtro = '';">
              <span>Ok</span>
            </button>
          </footer>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import toastr from 'toastr';
  import RSessao from '@/components/Rest/RSessao';
  import store from '@/ambiente/store';
  import RAlinea from '@/components/Rest/RAlinea';
  import RConta from '@/components/Rest/RConta';
  import RPortador from '@/components/Rest/RPortador';
  import Biblioteca from '@/components/Repositorio/Biblioteca';

  export default {
    name: 'ConfiguracoesFinanceiro',

    data() {
      const self = this;

      return {
        cConfiguracoes_Mapa_Financeiro: 'configuracoes-mapa-financeiro',

        visivel: false,
        mostrar_modal_contas_desconsiderar_ids: false,
        mostrar_modal_contas_caixa: false,
        mostrar_modal_empresas: false,
        mostrar_modal_portadores_pagar: false,
        mostrar_modal_portadores_contas_receber: false,
        mostrar_modal_alineas: false,

        configuracoes: {},

        configuracoes_padroes: {
          quantidade_dias: 7,
          tipo_saldo: 'TSE',

          formas_pagamento: {
            forma_boleto: true,
            forma_credito: true,
            forma_cheque_prazo: true,
            forma_cheque_vista: true,
            forma_duplicata: true,
            forma_previsao: true
          },
          
          omissoes: {
            caixas: false,
            empresas: false,
            portadores_a_receber: false,
            portadores_a_pagar: false,
            alineas: false
          },

          saldo_conta_fluxo: 0,

          contas_desconsiderar_ids: [],
          contas_caixa_ids: [],
          empresas_ids: [],
          portadores_contas_receber_ids: [],
          portadores_contas_pagar_ids: [],
          alineas_cheques_pagar_ids: [],

          visibilidade: {
            conta_caixa: true,
            contas_desconsiderar_ids: true,
            receber_realizado: true,
            cheques_pagar: true,
            pagar_duplicata_cheques_abertos: true,
            dbc_pagar_vencidos: true,
            pagar_previsoes: true,
            receber_previsoes: true,
            tres_dias: true,
            quinze_dias: true,
            trinta_dias: true,
            sessenta_dias: true,
            noventa_dias: true,
            previsoes_pagar_vencidas: true
          }
        },

        ativar_todos_financeiro: false,
        desativar_todos_financeiro: true,

        filtro: '',

        contas_desconsiderar_ids: [],
        empresas: [],
        contas_caixa: [],
        portadores_pagar: [],
        portadores_receber: [],
        alineas: [],

        processando: true
      }
    },

    watch: {
      mostrar_modal_contas_desconsiderar_ids() {
        this.verificarModalAberto();   
      },

      mostrar_modal_empresas() {
        this.verificarModalAberto();   
      },

      mostrar_modal_portadores_pagar() {
        this.verificarModalAberto();  
      },

      mostrar_modal_portadores_contas_receber() {
        this.verificarModalAberto();   
      },

      mostrar_modal_alineas() {
        this.verificarModalAberto();   
      }
    },

    computed: {
      temContaDesconsiderarSelecionada() {
        if (!this.contas_desconsiderar_ids) {
          return false;
        }

        for (let i = 0; i < this.contas_desconsiderar_ids.length; i++) {
          if (this.contas_desconsiderar_ids[i].selecionada) {
            return true;
          }
        }

        return false;
      },

      temContaCaixaSelecionada() {
        if (!this.contas_caixa) {
          return false;
        }

        for (let i = 0; i < this.contas_caixa.length; i++) {
          if (this.contas_caixa[i].selecionada) {
            return true;
          }
        }

        return false;
      },

      temEmpresaSelecionada() {
        if (!this.empresas) {
          return false;
        }

        for (let i = 0; i < this.empresas.length; i++) {
          if (this.empresas[i].selecionada) {
            return true;
          }
        }

        return false;
      },

      temPortadorPagarSelecionado() {
        if (!this.portadores_pagar) {
          return false;
        }

        for (let i = 0; i < this.portadores_pagar.length; i++) {
          if (this.portadores_pagar[i].selecionado) {
            return true;
          }
        }

        return false;
      },

      temPortadorReceberSelecionado() {
        if (!this.portadores_receber) {
          return false;
        }

        for (let i = 0; i < this.portadores_receber.length; i++) {
          if (this.portadores_receber[i].selecionado) {
            return true;
          }
        }

        return false;
      },

      temAlineaSelecionada() {
        if (!this.alineas) {
          return false;
        }

        for (let i = 0; i < this.alineas.length; i++) {
          if (this.alineas[i].selecionada) {
            return true;
          }
        }

        return false;
      },

      buscarContasDesconsiderarFiltradas() {
        if ((!this.contas_desconsiderar_ids) || (this.contas_desconsiderar_ids.length == 0)) {
          return [];
        }

        let retorno = [];

        let filtro_tratado = this.filtro;
        if (filtro_tratado) {
          filtro_tratado = filtro_tratado.toUpperCase();
        }

        for (let i = 0; i < this.contas_desconsiderar_ids.length; i++) {
          if (
            (filtro_tratado == '') || 
            (this.contas_desconsiderar_ids[i].conta_id.toUpperCase().indexOf(filtro_tratado) > -1) ||
            (this.contas_desconsiderar_ids[i].nome_portador.toUpperCase().indexOf(filtro_tratado) > -1)
          ) {
            retorno.push(JSON.parse(JSON.stringify(this.contas_desconsiderar_ids[i])));
          }
        }

        return retorno;
      },

      buscarContasCaixaFiltradas() {
        if ((!this.contas_caixa) || (this.contas_caixa.length == 0)) {
          return [];
        }

        let retorno = [];

        let filtro_tratado = this.filtro;
        if (filtro_tratado) {
          filtro_tratado = filtro_tratado.toUpperCase();
        }

        for (let i = 0; i < this.contas_caixa.length; i++) {
          if (
            (filtro_tratado == '') || 
            (this.contas_caixa[i].conta_id.toUpperCase().indexOf(filtro_tratado) > -1) ||
            (this.contas_caixa[i].nome_portador.toUpperCase().indexOf(filtro_tratado) > -1)
          ) {
            retorno.push(JSON.parse(JSON.stringify(this.contas_caixa[i])));
          }
        }

        return retorno;
      },

      buscarEmpresasFiltradas() {
        if ((!this.empresas) || (this.empresas.length == 0)) {
          return [];
        }

        let retorno = [];

        let filtro = this.filtro;
        if (filtro) {
          filtro = filtro.toUpperCase();
        }

        for (let i = 0; i < this.empresas.length; i++) {
          if (
            (this.filtro == '') || 
            (this.empresas[i].empresa_id.indexOf(filtro) > -1) ||
            (this.empresas[i].nome_fantasia.toUpperCase().indexOf(filtro) > -1)
          ) {
            retorno.push(JSON.parse(JSON.stringify(this.empresas[i])));
          }
        }

        return retorno;
      },

      buscarPortadoresPagarFiltrados() {
        if ((!this.portadores_pagar) || (this.portadores_pagar.length == 0)) {
          return [];
        }

        let retorno = [];

        let filtro = this.filtro;
        if (filtro) {
          filtro = filtro.toUpperCase();
        }

        for (let i = 0; i < this.portadores_pagar.length; i++) {
          if (
            (this.filtro == '') || 
            (this.portadores_pagar[i].portador_id.indexOf(filtro) > -1) ||
            (this.portadores_pagar[i].nome.toUpperCase().indexOf(filtro) > -1)
          ) {
            retorno.push(JSON.parse(JSON.stringify(this.portadores_pagar[i])));
          }
        }

        return retorno;
      },

      buscarPortadoresReceberFiltrados() {
        if ((!this.portadores_receber) || (this.portadores_receber.length == 0)) {
          return [];
        }

        let retorno = [];

        let filtro = this.filtro;
        if (filtro) {
          filtro = filtro.toUpperCase();
        }

        for (let i = 0; i < this.portadores_receber.length; i++) {
          if (
            (this.filtro == '') || 
            (this.portadores_receber[i].portador_id.indexOf(filtro) > -1) ||
            (this.portadores_receber[i].nome.toUpperCase().indexOf(filtro) > -1)
          ) {
            retorno.push(JSON.parse(JSON.stringify(this.portadores_receber[i])));
          }
        }

        return retorno;
      },

      buscarAlineasFiltradas() {
        if ((!this.alineas) || (this.alineas.length == 0)) {
          return [];
        }

        let retorno = [];

        let filtro = this.filtro;
        if (filtro) {
          filtro = filtro.toUpperCase();
        }

        for (let i = 0; i < this.alineas.length; i++) {
          if (
            (this.filtro == '') || 
            (this.alineas[i].alinea_id.indexOf(filtro) > -1) ||
            (this.alineas[i].nome.toUpperCase().indexOf(filtro) > -1)
          ) {
            retorno.push(JSON.parse(JSON.stringify(this.alineas[i])));
          }
        }

        return retorno;
      },

      getTituloBotaoTiposDocumentos() {
        let retorno = 'Marcar todos';

        let todos_marcados = this.todosTiposDocumentosMarcados();
        if (todos_marcados) {
          retorno = 'Desmarcar todos';
        }

        return retorno;
      },

      verificarModal() {
        if (
          this.mostrar_modal_contas_desconsiderar_ids || 
          this.mostrar_modal_contas_caixa ||
          this.mostrar_modal_empresas ||
          this.mostrar_modal_portadores_pagar ||
          this.mostrar_modal_portadores_contas_receber ||
          this.mostrar_modal_alineas
        ) {
          return true;
        }
        
        return false;
      },

      selecionouFormaPagamento() {
        for (let item in this.configuracoes.formas_pagamento) {
          if (this.configuracoes.formas_pagamento[item]) {
            return true;
          }
        }

        return false;
      },

      existeFalseFinanceiro() {
        for (let item in this.configuracoes.visibilidade) {
          if (this.configuracoes.visibilidade[item]) {
            return 'N';
          }
        }
        return 'S';
      }
    },

    methods: {
      abrir() {
        this.visivel = true;
      },

      fechar() {
        this.visivel = false;
      },

      contaCaixaSelecionada(conta_id) {
        if (
          (!this.configuracoes) || 
          (!this.configuracoes.contas_caixa_ids) || 
          (this.configuracoes.contas_caixa_ids.length == 0)
        ) {
          return false;
        }

        for (let i = 0; i < this.configuracoes.contas_caixa_ids.length; i++) {
          if (this.configuracoes.contas_caixa_ids[i] == conta_id) {
            return true;
          }
        }

        return false;
      },

      verificarModalAberto() {
        const el = document.documentElement;

        if (this.verificarModal) {
          el.classList.add('modal-aberto');
        }
        else {
          el.classList.remove('modal-aberto');
        } 
      },

      todosTiposDocumentosMarcados() {
        let retorno = true;

        if (
          !this.configuracoes.formas_pagamento.forma_boleto ||
          !this.configuracoes.formas_pagamento.forma_credito ||
          !this.configuracoes.formas_pagamento.forma_cheque_prazo ||
          !this.configuracoes.formas_pagamento.forma_cheque_vista ||
          !this.configuracoes.formas_pagamento.forma_duplicata ||
          !this.configuracoes.formas_pagamento.forma_previsao
        ) {
          retorno = false;
        }

        return retorno;
      },

      marcarDesmarcarTodosTiposDocumento() {
        let tudo_marcado = this.todosTiposDocumentosMarcados();

        this.configuracoes.formas_pagamento.forma_boleto = !tudo_marcado;
        this.configuracoes.formas_pagamento.forma_credito = !tudo_marcado;
        this.configuracoes.formas_pagamento.forma_cheque_prazo = !tudo_marcado;
        this.configuracoes.formas_pagamento.forma_cheque_vista = !tudo_marcado;
        this.configuracoes.formas_pagamento.forma_duplicata = !tudo_marcado;
        this.configuracoes.formas_pagamento.forma_previsao = !tudo_marcado;
        
        this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes));
      },

      ativarDesativarFinanceiro(status) {
        for (let i in this.configuracoes.visibilidade) {
          this.configuracoes.visibilidade[i] = status;
        }

        if (this.existeFalseFinanceiro == 'S') {
          this.ativar_todos_financeiro = true;
          this.desativar_todos_financeiro = false;
        }
        else {
          this.desativar_todos_financeiro = true;
          this.ativar_todos_financeiro = false;
        }
      },

      montarObjetoConfiguracoesTela() {
        let retorno = {
          formas_pagamento: {
            forma_boleto: this.configuracoes.formas_pagamento.forma_boleto,
            forma_credito: this.configuracoes.formas_pagamento.forma_credito,
            forma_cheque_prazo: this.configuracoes.formas_pagamento.forma_cheque_prazo,
            forma_cheque_vista: this.configuracoes.formas_pagamento.forma_cheque_vista,
            forma_duplicata: this.configuracoes.formas_pagamento.forma_duplicata,
            forma_previsao: this.configuracoes.formas_pagamento.forma_previsao
          },

          omissoes: {
            empresas: this.configuracoes.omissoes.empresas,
            portadores_a_receber: this.configuracoes.omissoes.portadores_a_receber,
            portadores_a_pagar: this.configuracoes.omissoes.portadores_a_pagar,
            alineas: this.configuracoes.omissoes.alineas
          },

          visibilidade: {
            contas_caixa: this.configuracoes.visibilidade.contas_caixa,
            contas_bancarias: this.configuracoes.visibilidade.contas_bancarias,
            receber_realizado: this.configuracoes.visibilidade.receber_realizado,
            cheques_pagar: this.configuracoes.visibilidade.cheques_pagar,
            pagar_duplicata_cheques_abertos: this.configuracoes.visibilidade.pagar_duplicata_cheques_abertos,
            dbc_pagar_vencidos: this.configuracoes.visibilidade.dbc_pagar_vencidos,
            pagar_previsoes: this.configuracoes.visibilidade.pagar_previsoes,
            receber_previsoes: this.configuracoes.visibilidade.receber_previsoes,
            tres_dias: this.configuracoes.visibilidade.tres_dias,
            quinze_dias: this.configuracoes.visibilidade.quinze_dias,
            trinta_dias: this.configuracoes.visibilidade.trinta_dias,
            sessenta_dias: this.configuracoes.visibilidade.sessenta_dias,
            noventa_dias: this.configuracoes.visibilidade.noventa_dias,
            previsoes_pagar_vencidas: this.configuracoes.visibilidade.previsoes_pagar_vencidas
          },

          quantidade_dias: this.configuracoes.quantidade_dias,
          tipo_saldo: this.configuracoes.tipo_saldo,
          saldo_conta_fluxo: 0,
          contas_desconsiderar_ids: [],
          contas_caixa_ids: [],
          empresas_ids: [],
          portadores_contas_receber_ids: [],
          portadores_contas_pagar_ids: [],
          alineas_cheques_pagar_ids: []
        }

        if (this.configuracoes.tipo_saldo == 'TSD') {
          retorno.saldo_conta_fluxo = this.configuracoes.saldo_conta_fluxo;
        }

        if ((this.contas_desconsiderar_ids) && (this.contas_desconsiderar_ids.length > 0)) {
          for (let i = 0; i < this.contas_desconsiderar_ids.length; i++) {
            if (this.contas_desconsiderar_ids[i].selecionada) {
              retorno.contas_desconsiderar_ids.push(this.contas_desconsiderar_ids[i].conta_id);
            }
          }
        }

        for (let i = 0; i < this.contas_caixa.length; i++) {
          if (this.contas_caixa[i].selecionada) {
            retorno.contas_caixa_ids.push(this.contas_caixa[i].conta_id);
          }          
        }

        for (let i = 0; i < this.empresas.length; i++) {
          if (this.empresas[i].selecionada) {
            retorno.empresas_ids.push(this.empresas[i].empresa_id);
          }          
        }

        for (let i = 0; i < this.portadores_pagar.length; i++) {
          if (this.portadores_pagar[i].selecionado) {
            retorno.portadores_contas_pagar_ids.push(this.portadores_pagar[i].portador_id);
          }
        }

        for (let i = 0; i < this.portadores_receber.length; i++) {
          if (this.portadores_receber[i].selecionado) {
            retorno.portadores_contas_receber_ids.push(this.portadores_receber[i].portador_id);
          }
        }

        for (let i = 0; i < this.alineas.length; i++) {
          if (this.alineas[i].selecionada) {
            retorno.alineas_cheques_pagar_ids.push(this.alineas[i].alinea_id);
          }
        }

        return retorno;
      },

      gravarConfiguracoes() {
        if (this.existeFalseFinanceiro == 'S') {
          toastr.error('Pelo menos um card deve ser habilitado!')
          return;
        }

        if (
          (!this.configuracoes.quantidade_dias) || 
          (this.configuracoes.quantidade_dias == 0) || 
          (this.configuracoes.quantidade_dias == '')
        ) {
          toastr.error('A quantidade de dias deve ser informada!');
          return;
        }

        if(this.configuracoes.quantidade_dias < 0) {
          toastr.error('A quantidade de dias não pode ser menor que zero.');
          return;
        }

        if (!this.temContaCaixaSelecionada) {
          toastr.error('Pelo menos uma conta caixa tem que ser selecionada!');
          return;
        }

        if (!this.temEmpresaSelecionada) {
          toastr.error('Pelo menos uma empresa não deve ser omitida!');
          return;
        }

        else if(!this.selecionouFormaPagamento) {
          toastr.error('Selecione uma forma de pagamento!');
          return;
        }

        /*

        if (
          (this.configuracoes.omissoes.portadores_a_pagar) && 
          (
            this.portadores_contas_pagar_selecionados.length == 
            this.portadores_contas_pagar_disponiveis.length
          )
        ) {
          toastr.error('Pelo menos uma conta a pagar não deve ser omitida!');
          return;
        }
        
        if (
          (this.configuracoes.omissoes.portadores_a_receber) &&
          (
            this.portadores_receber.length == 
            this.portadores_contas_receber_disponiveis.length
          )
        ) {
          toastr.error('Pelo menos uma conta a receber não deve ser omitida!');
          return;
        }

        if (
          (this.configuracoes.omissoes.alineas) &&
          (this.alineas_selecionadas.length == this.alineas_disponiveis.length)
        ) {
          toastr.error('Pelo menos uma conta a pagar não deve ser omitida!');
          return;
        }

        */

        let objeto = this.montarObjetoConfiguracoesTela();
        localStorage.setItem(this.cConfiguracoes_Mapa_Financeiro, JSON.stringify(objeto));

        swal("Configurações gravadas com sucesso!", 'O que deseja fazer agora?', 'success', {
          buttons: {
            nao: "Permanecer em configurações",
            sim: "Ir para mapa financeiro",
          },
        })
        .then((value) => {
          switch (value) {
            case "sim":
              this.$emit('confirmar');
              this.fechar();   
          }
        });
      },

      mostrarModal(idModal) {
        document.getElementById(idModal).style.display = 'block';
      },

      async buscarContasBancarias() {
        let parametros = {tipo_pesquisa: 'CB'};
        let retorno = await RConta.buscarContas(this.axios, parametros);
        if (retorno.houve_erro != 'N') {
          retorno = {
            dados: []
          };
        }
        return retorno.dados;
      },

      async buscarContasCaixa() {
        let parametros = {tipo_pesquisa: 'CC'};
        let retorno = await RConta.buscarContas(this.axios, parametros);
        if (retorno.houve_erro != 'N') {
          retorno = {
            dados: []
          };
        }
        return retorno.dados;
      },

      async buscarPortadorContasPagar() {
        let parametros = {
          tipo_pesquisa: 'PCP'
        }
        let retorno = await RPortador.buscarPortadores(this.axios, parametros);
        if (retorno.houve_erro != 'N') {
          retorno = {
            dados: []
          };
        }
        return retorno.dados;
      },

      async buscarPortadorContasReceber() {
        let parametros = {
          tipo_pesquisa: 'PCR'
        }

        let retorno = await RPortador.buscarPortadores(this.axios, parametros);
        if (retorno.houve_erro != 'N') {
          retorno = {
            dados: []
          };
        }
        return retorno.dados;
      },

      async buscarAlineas() {
        let retorno = await RAlinea.buscarAlineas(this.axios);
        if (retorno.houve_erro != 'N') {
          retorno = {
            dados: []
          };
        }
        return retorno.dados;
      },

      async buscarTodosDados() {
        this.contas_desconsiderar_ids = await this.buscarContasBancarias();
        for (let i = 0; i < this.contas_desconsiderar_ids.length; i++) {
          this.contas_desconsiderar_ids[i].selecionada = false;
        }

        this.contas_caixa = await this.buscarContasCaixa();
        for (let i = 0; i < this.contas_caixa.length; i++) {
          this.contas_caixa[i].selecionada = false;
        }

        if (!RSessao.carregouSessao()) {
          await RSessao.buscarDadosCarregarSessao(this.axios);
        }

        this.empresas = JSON.parse(JSON.stringify(await store.state.empresas_autorizadas));
        for (let i = 0; i < this.empresas.length; i++) {
          this.empresas[i].selecionada = false;
        }

        this.portadores_pagar = await this.buscarPortadorContasPagar();
        for (let i = 0; i < this.portadores_pagar.length; i++) {
          this.portadores_pagar[i].selecionado = false;
        }

        this.portadores_receber = await this.buscarPortadorContasReceber();
        for (let i = 0; i < this.portadores_receber.length; i++) {
          this.portadores_receber[i].adicionado = false;
        }

        this.alineas = await this.buscarAlineas();
        for (let i = 0; i < this.alineas.length; i++) {
          this.alineas[i].selecionada = false;
        }

        this.carregarConfiguracoesDispositivo();
      },

      buscarClasseSelecao(selecionada) {
        if (selecionada) {
          return 'w3-theme label-clicavel';
        }
        else {
          return 'w3-white label-clicavel';
        }
      },

      omitirEmpresas() {
        this.configuracoes.omissoes.empresas = !this.configuracoes.omissoes.empresas;
        this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes));
      },

      omitirPortadoresContasPagar() {
        this.configuracoes.omissoes.portadores_a_pagar = !this.configuracoes.omissoes.portadores_a_pagar;
        this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes));
      },

      omitirPortadoresContasReceber() {
        this.configuracoes.omissoes.portadores_a_receber = !this.configuracoes.omissoes.portadores_a_receber;
        this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes));
      },

      omitirAlineas() {
        this.configuracoes.omissoes.alineas = !this.configuracoes.omissoes.alineas;
        this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes));
      },

      carregarConfiguracoesDispositivo() {
        this.processando = true;

        if (!localStorage.getItem(this.cConfiguracoes_Mapa_Financeiro)) {
          this.processando = false;
          return;
        }

        let conf_local = JSON.parse(localStorage.getItem(this.cConfiguracoes_Mapa_Financeiro));
        if (!conf_local) {
          this.processando = false;
          return;
        }

        if (
          (conf_local.contas_desconsiderar_ids) &&
          (conf_local.contas_desconsiderar_ids.length > 0)
        ) {
          for (let i = 0; i < conf_local.contas_desconsiderar_ids.length; i++) {
            this.adicionarRemoverContaDesconsiderar(conf_local.contas_desconsiderar_ids[i], true);
          }
        }

        if (
          (conf_local.contas_caixa_ids) &&
          (conf_local.contas_caixa_ids.length > 0)
        ) {
          for (let i = 0; i < conf_local.contas_caixa_ids.length; i++) {
            this.adicionarRemoverContaCaixa(conf_local.contas_caixa_ids[i], true);
          }
        }

        if (
          (conf_local.empresas_ids) &&
          (conf_local.empresas_ids.length > 0)
        ) {
          for (let i = 0; i < conf_local.empresas_ids.length; i++) {
            this.adicionarRemoverEmpresa(conf_local.empresas_ids[i], true);
          }
        }

        if (
          (conf_local.portadores_contas_pagar_ids) &&
          (conf_local.portadores_contas_pagar_ids.length > 0)
        ) {
          for (let i = 0; i < conf_local.portadores_contas_pagar_ids.length; i++) {
            this.adicionarRemoverPortadorContasPagar(conf_local.portadores_contas_pagar_ids[i], true);
          }
        }

        if (
          (conf_local.portadores_contas_receber_ids) &&
          (conf_local.portadores_contas_receber_ids.length > 0)
        ) {
          for (let i = 0; i < conf_local.portadores_contas_receber_ids.length; i++) {
            this.adicionarRemoverPortadorContasReceber(conf_local.portadores_contas_receber_ids[i], true);
          }
        }

        if (
          (conf_local.alineas_cheques_pagar_ids) &&
          (conf_local.alineas_cheques_pagar_ids.length > 0)
        ) {
          for (let i = 0; i < conf_local.alineas_cheques_pagar_ids.length; i++) {
            this.adicionarRemoverAlinea(conf_local.alineas_cheques_pagar_ids[i], true);
          }
        }

        this.configuracoes = JSON.parse(JSON.stringify(conf_local));
        this.processando = false;
      },

      adicionarRemoverContaDesconsiderar(conta_id, selecionar) {
        let excluiu = false;
        for (let i = 0; i < this.contas_desconsiderar_ids.length; i++) {
          if (this.contas_desconsiderar_ids[i].conta_id == conta_id) {
            this.contas_desconsiderar_ids[i].selecionada = selecionar;
            break;
          }
        }

        this.contas_desconsiderar_ids = JSON.parse(JSON.stringify(this.contas_desconsiderar_ids));
      },

      adicionarRemoverContaCaixa(conta_id, selecionar) {
        let excluiu = false;
        for (let i = 0; i < this.contas_caixa.length; i++) {
          if (this.contas_caixa[i].conta_id == conta_id) {
            this.contas_caixa[i].selecionada = selecionar;
            break;
          }
        }

        this.contas_caixa = JSON.parse(JSON.stringify(this.contas_caixa));
      },

      adicionarRemoverEmpresa(empresa_id, selecionar){
        let excluiu = false;
        for (let i = 0; i < this.empresas.length; i++) {
          if (this.empresas[i].empresa_id == empresa_id) {
            this.empresas[i].selecionada = selecionar;
            break;
          }
        }

        this.empresas = JSON.parse(JSON.stringify(this.empresas));
      },

      adicionarRemoverPortadorContasPagar(portador_id, selecionar) {
        let excluiu = false;
        for (let i = 0; i < this.portadores_pagar.length; i++) {
          if (this.portadores_pagar[i].portador_id == portador_id) {
            this.portadores_pagar[i].selecionado = selecionar;
            break;
          }
        }

        this.portadores_pagar = JSON.parse(JSON.stringify(this.portadores_pagar));
      },

      adicionarRemoverPortadorContasReceber(portador_id, selecionar) {
        let excluiu = false;
        for (let i = 0; i < this.portadores_receber.length; i++) {
          if (this.portadores_receber[i].portador_id == portador_id) {
            this.portadores_receber[i].selecionado = selecionar;
            break;
          }
        }

        this.portadores_receber = JSON.parse(JSON.stringify(this.portadores_receber));
      },

      adicionarRemoverAlinea(alinea_id, selecionar) {
        let excluiu = false;
        for (let i = 0; i < this.alineas.length; i++) {
          if (this.alineas[i].alinea_id == alinea_id) {
            this.alineas[i].selecionada = selecionar;
            break;
          }
        }

        this.alineas = JSON.parse(JSON.stringify(this.alineas));
      },

      carregarConfiguracoesLocais() {
        if (localStorage.getItem(this.cConfiguracoes_Mapa_Financeiro)) {
          this.configuracoes = JSON.parse(localStorage.getItem(this.cConfiguracoes_Mapa_Financeiro))
        }
      },

      limparConfiguracoes() {
        swal(
          'Deseja realmente limpar as configuracões?',
          {
            buttons: {
              nao: 'Não',
              sim: 'Sim',
            },
          }
        )
        .then(
          (value) => {
            switch (value) {
              case 'sim':
                localStorage.removeItem(this.cConfiguracoes_Mapa_Financeiro);
                this.carregarConfiguracoesPadroes();
            }
          }
        );
      },

      carregarConfiguracoesPadroes() {
        this.configuracoes = JSON.parse(JSON.stringify(this.configuracoes_padroes));
        
        this.contas_desconsiderar_ids = [];
        this.empresas = [];
        this.contas_caixa = [];
        this.portadores_pagar = [];
        this.portadores_receber = [];
        this.alineas = [];
      },

      simNaoString(sn) {
        return Biblioteca.simNaoString(sn);
      }
    },

    created() {
      this.carregarConfiguracoesPadroes();
      this.carregarConfiguracoesLocais();
      this.buscarTodosDados();
    }
  }
</script>

<style scoped>
  .agrupador {
    color: #000000;
    background-color: #bbbbbb;
    margin: 10px 10px 0 0;
    border-radius: 10px;
    padding: 4px;    
  }

  .box_configuracoes {
    float: left;
    width: 100%;
    clear: both;
  }

  .grupo-contas-pagar > .w3-col:not(:last-child) {
    margin-bottom: 5px
  }

  .opcoes_avancadas {
    margin-top: 20px;
    cursor: pointer;
    text-decoration: underline;
  }

  .checkbox-group label {
    cursor: pointer;
  }

  .switch-input {
    display: none;
  }
  .switch-label {
    position: relative;
    display: inline-block;
    min-width: 112px;
    cursor: pointer;
    text-align: left;
    padding: 10px 0 10px 44px;
  }

  .switch-label:before, .switch-label:after {
    content: "";
    position: absolute;
    margin: 0;
    outline: 0;
    top: 50%;
    -ms-transform: translate(0, -50%);
    -webkit-transform: translate(0, -50%);
    transform: translate(0, -50%);
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }

  .switch-label:before {
    left: 1px;
    width: 34px;
    height: 14px;
    background-color: #9E9E9E;
    border-radius: 8px;
  }

  .switch-label:after {
    left: 0;
    width: 20px;
    height: 20px;
    background-color: #FAFAFA;
    border-radius: 50%;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.098), 0 1px 5px 0 rgba(0, 0, 0, 0.084);
  }

  .switch-label .toggle--on {
    display: none;
  }

  .switch-label .toggle--off {
    display: inline-block;
  }

  .switch-input:checked + .switch-label:before {
    background-color: #34ACFE;
  }

  .switch-input:checked + .switch-label:after {
    background-color: #0080d6;
    -ms-transform: translate(80%, -50%);
    -webkit-transform: translate(80%, -50%);
    transform: translate(80%, -50%);
  }

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

  ::-webkit-scrollbar-track {
    background: #ddd; 
  }
  
  ::-webkit-scrollbar-thumb {
    background: #8d1007; 
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #9c1d1c; 
  }

  th, td{
    white-space: nowrap !important
  }

  .w3-modal {
    padding-top: 50px !important
  }

  .items {
    background-color:#f5f5f5;
    border-radius: 10px;
  }

  .bloco {
    border: 1px solid #999;
    background-color: #ffffffbb;
    float: left;
    margin-top: 15px;
    border-radius:4px;
  }

  .bloco div div {       
    line-height: 18px;
  }

  .bloco .w3-row {
    padding:  5px 10px;    
  }

  .bloco button {
    height: 20px;
    line-height: 20px;
    padding:0;
    text-decoration:underline;
    font-size: 13px;
  }

  .borda-pontilhada {
    border: 1px dotted #666666;
    margin-top: 5px;
  }
</style>




// WEBPACK FOOTER //
// src/components/ConfiguracoesFinanceiro.vue